<template>
    <div class="stepDescription">
        <p>{{ stepDescription }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            stepDescription: {
                type: String,
                required: false
            },
        }
    }
</script>

<style lang="scss">
    @import "@vuxx/hounds/scss/abstracts/mixins";
    @import "@vuxx/hounds/scss/abstracts/variables";

    .stepDescription{
        display: flex;
        align-self: center;
        width: 90%;
        font-size: 16px;
        font-weight: 500;
        color: #435254;
    }

    .stepDescription p{
        margin: 0;
    }
</style>
